import React from "react";
import { NavLink } from "react-router-dom";
import {
  ContentIcon,
  GalleryIcon,
  GiveawayIcon,
  HelpIcon,
  MembersIcon,
  PollsIcon,
  getIcon,
} from "../../../../utils/icons.jsx";
import { getItem } from "../utils";

const clubAdminGroupsSideNavLinks = getItem(
  "Groups",
  "sub9",
  getIcon(22, MembersIcon),
  [
    getItem(
      <NavLink to="/clubadmin/groups" className="nav-link default-text-color">
        Groups
      </NavLink>,
      "/clubadmin/groups",
    ),
    getItem(
      <NavLink to="/clubadmin/members" className="nav-link default-text-color">
        Members
      </NavLink>,
      "/clubadmin/members",
    ),
    getItem(
      <NavLink
        to="/clubadmin/membership"
        className="nav-link default-text-color"
      >
        Card
      </NavLink>,
      "/clubadmin/membership",
    ),
  ],
);

const clubAdminContentSideNavLinks = getItem(
  "Content",
  "sub10",
  getIcon(22, ContentIcon),
  [
    getItem(
      <NavLink to="/clubadmin/content" className="nav-link default-text-color">
        News/Events
      </NavLink>,
      "/clubadmin/content",
    ),
    getItem(
      <NavLink to="/clubadmin/chants" className="nav-link default-text-color">
        Chants
      </NavLink>,
      "/clubadmin/chants",
    ),
    getItem(
      <NavLink
        to="/clubadmin/content/locations"
        className="nav-link default-text-color"
      >
        Locations
      </NavLink>,
      "/clubadmin/content/locations",
    ),
  ],
);

const clubAdminGallerySideNavLinks = getItem(
  <NavLink to="/clubadmin/gallery" className="nav-link default-text-color">
    Gallery
  </NavLink>,
  "/clubadmin/gallery",
  getIcon(22, GalleryIcon),
);

const clubAdminPollsSideNavLinks = getItem(
  <NavLink to="/clubadmin/polls" className="nav-link default-text-color">
    Polls
  </NavLink>,
  "/clubadmin/polls",
  getIcon(22, PollsIcon),
);

const clubAdminGiveawaySideNavLinks = getItem(
  <NavLink to="/clubadmin/giveaways" className="nav-link default-text-color">
    Giveaways
  </NavLink>,
  "/clubadmin/giveaways",
  getIcon(22, GiveawayIcon),
);

const clubAdminHelpSideNavLinks = getItem(
  <NavLink to="/clubadmin/help" className="nav-link default-text-color">
    Help
  </NavLink>,
  "/clubadmin/help",
  getIcon(22, HelpIcon),
);

export default [
  clubAdminGroupsSideNavLinks,
  clubAdminContentSideNavLinks,
  clubAdminGallerySideNavLinks,
  clubAdminPollsSideNavLinks,
  clubAdminGiveawaySideNavLinks,
  clubAdminHelpSideNavLinks,
];
